"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _default = {
    "383101106": 66.9,
    "384101106": 51.1,
    "385101106": 31.9,
    "386101106": 21.1,
    "387101106": 13.2,
    "388101106": 3.9,
    "383101107": 68.8,
    "384101107": 51.6,
    "385101107": 31,
    "386101107": 19.9,
    "387101107": 12,
    "388101107": 3.2,
    "383101108": 66.9,
    "384101108": 51.1,
    "385101108": 31.9,
    "386101108": 21.1,
    "387101108": 13.2,
    "388101108": 3.9,
    "383101109": 66.9,
    "384101109": 51.1,
    "385101109": 31.9,
    "386101109": 21.1,
    "387101109": 13.2,
    "388101109": 3.9,
    "383101110": 66.9,
    "384101110": 51.1,
    "385101110": 31.9,
    "386101110": 21.1,
    "387101110": 13.2,
    "388101110": 3.9,
    "383101111": 66.9,
    "384101111": 51.1,
    "385101111": 31.9,
    "386101111": 21.1,
    "387101111": 13.2,
    "388101111": 3.9,
    "383101112": 66.9,
    "384101112": 51.1,
    "385101112": 31.9,
    "386101112": 21.1,
    "387101112": 13.2,
    "388101112": 3.9,
    "383101113": 66.9,
    "384101113": 51.1,
    "385101113": 31.9,
    "386101113": 21.1,
    "387101113": 13.2,
    "388101113": 3.9,
    "383101114": 68.6,
    "384101114": 52.6,
    "385101114": 33.2,
    "386101114": 22.1,
    "387101114": 13.9,
    "388101114": 4.2,
    "383101115": 68.6,
    "384101115": 52.6,
    "385101115": 33.2,
    "386101115": 22.1,
    "387101115": 13.9,
    "388101115": 4.2,
    "383101116": 66.9,
    "384101116": 51.1,
    "385101116": 31.9,
    "386101116": 21.1,
    "387101116": 13.2,
    "388101116": 3.9,
    "383101117": 64.2,
    "384101117": 49,
    "385101117": 30.3,
    "386101117": 19.9,
    "387101117": 12.4,
    "388101117": 3.6,
    "383101118": 68.8,
    "384101118": 51.6,
    "385101118": 31,
    "386101118": 19.9,
    "387101118": 12,
    "388101118": 3.2,
    "383101119": 67.3,
    "384101119": 52.7,
    "385101119": 34.7,
    "386101119": 23.9,
    "387101119": 15.7,
    "388101119": 5.2,
    "383101124": 67.3,
    "384101124": 52.7,
    "385101124": 34.7,
    "386101124": 23.9,
    "387101124": 15.7,
    "388101124": 5.2,
    "383101125": 68.8,
    "384101125": 51.6,
    "385101125": 31,
    "386101125": 19.9,
    "387101125": 12,
    "388101125": 3.2,
    "383101126": 70.9,
    "384101126": 53.2,
    "385101126": 31.8,
    "386101126": 20.4,
    "387101126": 12.3,
    "388101126": 3.3,
    "383101127": 66.9,
    "384101127": 51.1,
    "385101127": 31.9,
    "386101127": 21.1,
    "387101127": 13.2,
    "388101127": 3.9,
    "383101128": 66.9,
    "384101128": 51.1,
    "385101128": 31.9,
    "386101128": 21.1,
    "387101128": 13.2,
    "388101128": 3.9,
    "383102106": 65.3,
    "384102106": 50.2,
    "385102106": 31.3,
    "386102106": 20.9,
    "387102106": 13.2,
    "388102106": 4,
    "383102107": 69.6,
    "384102107": 53.2,
    "385102107": 33.1,
    "386102107": 21.8,
    "387102107": 13.6,
    "388102107": 4,
    "383102108": 71.9,
    "384102108": 53.9,
    "385102108": 32.6,
    "386102108": 20.9,
    "387102108": 12.6,
    "388102108": 3.4,
    "383102115": 69.6,
    "384102115": 53.2,
    "385102115": 33.1,
    "386102115": 21.8,
    "387102115": 13.6,
    "388102115": 4,
    "383102116": 69.6,
    "384102116": 53.2,
    "385102116": 33.1,
    "386102116": 21.8,
    "387102116": 13.6,
    "388102116": 4,
    "383102119": 69.6,
    "384102119": 53.2,
    "385102119": 33.1,
    "386102119": 21.8,
    "387102119": 13.6,
    "388102119": 4,
    "383102120": 67.4,
    "384102120": 51.5,
    "385102120": 32,
    "386102120": 21.2,
    "387102120": 13.2,
    "388102120": 3.9,
    "383102121": 67.4,
    "384102121": 51.5,
    "385102121": 32,
    "386102121": 21.2,
    "387102121": 13.2,
    "388102121": 3.9,
    "383102122": 65.4,
    "384102122": 50.2,
    "385102122": 31.3,
    "386102122": 20.8,
    "387102122": 13,
    "388102122": 3.9,
    "383102124": 69.6,
    "384102124": 53.2,
    "385102124": 33.1,
    "386102124": 21.8,
    "387102124": 13.6,
    "388102124": 4,
    "383102128": 67.4,
    "384102128": 51.5,
    "385102128": 32,
    "386102128": 21.2,
    "387102128": 13.2,
    "388102128": 3.9,
    "383103106": 64.5,
    "384103106": 49.9,
    "385103106": 31.4,
    "386103106": 21.1,
    "387103106": 13.4,
    "388103106": 4.1,
    "383103115": 69.9,
    "384103115": 53,
    "385103115": 32.6,
    "386103115": 21.4,
    "387103115": 13.2,
    "388103115": 3.8,
    "383103119": 62,
    "384103119": 48.8,
    "385103119": 32.5,
    "386103119": 22.6,
    "387103119": 14.9,
    "388103119": 5.1,
    "383103123": 69.9,
    "384103123": 53,
    "385103123": 32.6,
    "386103123": 21.4,
    "387103123": 13.2,
    "388103123": 3.8
};

//# sourceMappingURL=data:application/json;base64,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